import { render } from "./comment.vue?vue&type=template&id=a1287b8c"
import script from "./comment.vue?vue&type=script&lang=js"
export * from "./comment.vue?vue&type=script&lang=js"

import "./comment.vue?vue&type=style&index=0&id=a1287b8c&lang=scss"

import exportComponent from "/tmp/build_b6f5290c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__